import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class DateDef {
  key?: string = uuid()
  type: 'date' = 'date'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: DateOptions = new DateOptions()
  rules?: Rule[]
}

export class DateOptions {
  defaultValue?: string | string[] // 根据类型不同而不同
  type?: 'date' | 'datetime' | 'datetimerange' | 'daterange' | 'year' | 'month'| 'monthrange' = 'date' // 暂只支持部分
  clearable?: boolean = true
  disabled?: DisabledType = false
  showLabel?: boolean = true
  labelWidth?: string | number
  required?: boolean = false
  format?: string
  defaultTime?: string[] = ['00:00:00', '23:59:59']
  placeholder?: string
  disabledDate?: (params: {form: any; rowForm: any}) => (date: Date) => boolean
  onChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any> }) => void
}
